module.exports = __webpack_public_path__ + "img/MFF2.290266ca.png";